import React,{ useState } from "react";
import TableCat from "../../components/TableCat/TableCat";
import { useNavigate } from "react-router-dom";
import { Box, TextField } from "@mui/material"; 
const CatSearch = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  

 

  const buttonStyle = {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "10px 20px",
    fontSize: "16px",
    borderRadius: "5px",
    cursor: "pointer",
    fontFamily: "Roboto",
    transition: "background-color 0.3s ease",
};


  const buttonHoverStyle = (event, isHovering) => {
    event.target.style.backgroundColor = isHovering ? "#0056b3" : "#007bff";
  };

  return (
    <div >
      <h1 style={{ fontFamily: "Roboto"}}>Category</h1>
    
      <button
        onClick={() => navigate("/add-category")}
        style={buttonStyle}
        onMouseEnter={(e) => buttonHoverStyle(e, true)}
        onMouseLeave={(e) => buttonHoverStyle(e, false)}
      >
        Create New Category
      </button>
      <Box className="search-container">
      <TextField
          label="Search"
          variant="outlined"
          margin="normal"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        </Box>
     
     
      <TableCat searchTerm={searchTerm} />
      
      
      
       
      </div>
   
  );
};

export default CatSearch;

